import { createPortal } from 'react-dom';
import React from 'react';
import { Tooltip } from 'react-tooltip';

const TooltipComponent = ({
	id,
	content,
	placement = 'bottom-start',
	offset = 0,
	disabled = false,
	dataTestId = 'tooltip',
	portal = false,
	children
}) => {
	const toolTipId = id || content || 'tooltip';

	const tooltipElement = !disabled && <Tooltip id={toolTipId} className="DS__tooltip-box" opacity={1} place={placement} offset={offset} noArrow />;

	return (
		<div className="DS__tooltip-wrapper">
			<span data-tooltip-id={toolTipId} data-tooltip-content={content} data-testid={`tooltip-${dataTestId}`}>
				{children}
			</span>

			{!disabled && (portal ? createPortal(tooltipElement, document.body) : tooltipElement)}
		</div>
	);
};

export default TooltipComponent;
